export default {
  // no config for ng now
}
